import React, { Fragment } from 'react';
import { Breadcrumbs } from '../../../../AbstractElements';
import PrintComponent from './Print';

const WholesaleOrderContain = () => {
    console.log('WholesaleOrderContain rendering');
    return (
        <Fragment>
            <PrintComponent />
        </Fragment >
    );
};
export default WholesaleOrderContain;